import { useEffect, useState } from 'react';
import { useAuthStore } from 'shared/stores/index.ts';
import type { UserRole } from 'types/user.ts';

export { UserRole } from 'types/user.ts';

export const useRoleGuard = (allowRoles: UserRole[]) => {
  const { user } = useAuthStore();
  const [isAllow, setIsAllow] = useState(user && allowRoles.includes(user.role));

  useEffect(() => {
    if (user && allowRoles.includes(user.role)) {
      setIsAllow(true);
    } else {
      setIsAllow(false);
    }
  }, [user?.role]);

  return isAllow;
};
